import React from "react";
import { Stack } from "react-bootstrap";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import useBreakpoint from "../../hooks/useBreakpoint";
import { isXOrSmaller } from "../../lib/utils";

const TournamentSidebar = (): React.JSX.Element => {
    const { tournamentId } = useParams();
    const breakpoint = useBreakpoint();

    return (
        <Stack
            gap={2}
            direction={
                isXOrSmaller("md", breakpoint) ? "horizontal" : "vertical"
            }
            className="tournamentSidebar"
        >
            <Link
                to={`/tournaments/${tournamentId}`}
                className="btn btn-primary"
            >
                Standings
            </Link>
            <Link
                to={`/tournaments/${tournamentId}/schedule`}
                className="btn btn-primary"
            >
                Schedule
            </Link>
            <Link
                to={`/tournaments/${tournamentId}/bracket`}
                className="btn btn-primary"
            >
                Playoff Brackets
            </Link>
        </Stack>
    );
};

export default TournamentSidebar;
